import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("antonio_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me", { silent: true });
      setUser(data);
    } catch {
      localStorage.removeItem("antonio_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("antonio_token", data.token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiError(e));
      return false;
    }
  };

  const register = async (name, email, password, plano = "gratis") => {
    setError(null);
    try {
      const { data } = await api.post("/auth/register", { name, email, password, plano });
      localStorage.setItem("antonio_token", data.token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatApiError(e));
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("antonio_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, error, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
